import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import { ICreateDrugDosageRequest, IDrugDosage, IUpdateDrugDosageRequest } from '../../entities/MME/MME';

export class DrugDosageApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/DrugDosage`;

    public static apiUrls = {
        getAll: `${DrugDosageApi.baseApiUrl}`,
        getByDrug: `${DrugDosageApi.baseApiUrl}/drug`,
    };

    public static async getAll(): Promise<IDrugDosage[]> {
        return this.sendApiRequest<IDrugDosage[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getAll,
        });
    }

    public static async getByDrug(drugId: number): Promise<IDrugDosage[]> {
        return this.sendApiRequest<IDrugDosage[]>({
            method: HttpMethodEnum.GET,
            path: `${this.apiUrls.getByDrug}/${drugId}`,
        });
    }

    public static async getByDrugAndRoute(drugId: number, routeId: number): Promise<IDrugDosage[]> {
        return this.sendApiRequest<IDrugDosage[]>({
            method: HttpMethodEnum.GET,
            path: `${this.apiUrls.getByDrug}/${drugId}/route/${routeId}`,
        });
    }

    public static async getById(id: number): Promise<IDrugDosage> {
        return this.sendApiRequest<IDrugDosage>({
            method: HttpMethodEnum.GET,
            path: `${this.apiUrls.getAll}/${id}`,
        });
    }

    public static async create(request: ICreateDrugDosageRequest): Promise<{ id: number }> {
        return this.sendApiRequest<{ id: number }>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.getAll,
            data: request,
        });
    }

    public static async update(id: number, request: IUpdateDrugDosageRequest): Promise<{ success: boolean }> {
        return this.sendApiRequest<{ success: boolean }>({
            method: HttpMethodEnum.PUT,
            path: `${this.apiUrls.getAll}/${id}`,
            data: request,
        });
    }

    public static async delete(id: number): Promise<{ success: boolean }> {
        return this.sendApiRequest<{ success: boolean }>({
            method: HttpMethodEnum.DELETE,
            path: `${this.apiUrls.getAll}/${id}`,
        });
    }
}
